import { Observable } from "rxjs";
import { get } from "../../../service/api";
import { ITokenPair } from "../../auth/interface/dto/token-pair";
import { ICategoryDto } from "../interface/category.dto";

export const getCategory = (
    tokens: ITokenPair,
): Observable<Array<ICategoryDto>> =>
    get<Array<ICategoryDto>>("/common/categories", undefined, tokens);
